import React, { Component } from 'react';
import Cookies from 'js-cookie';
import { connect } from 'react-redux';
import { revokeAuth } from 'app/models/auth/actions';
import { RootRoute } from 'app/constants/Routes';
import { applyMixins } from 'app/utils/mixins';
import { History } from 'app/services/history';
import { withHistory } from 'app/components/router/History';
import { getQuery } from 'app/models/route/selectors';
import { DMM_AUTH_COOKIE } from 'app/services/cookies/constants';
import { Subtract } from 'app/utils/types';
import { BrandContextValue, useBrand } from 'app/components/OrganizationContext';

interface IDeps {
  currentBrand: BrandContextValue;
}

interface IProps extends IDeps {
  history: History;
  revokeAuth: () => Promise<void>;
}

export const EIKAIWA_LOGOUT_ROUTE =
  'https://www.dmm.com/my/-/login/logout/=/type=gbutton/path=DRVESVwZTldRDlBRRFdIUwwIGFVfVEs_';

class Logout extends Component<IProps> {
  public componentDidMount() {
    const { currentBrand, revokeAuth: dispatchRevokeAuth, history } = this.props;

    // Clear active booking.
    dispatchRevokeAuth().then(() => {
      // TODO: Replace first party flag check with generic logout cookie behavior based on Brand
      if (currentBrand.firstPartyDmm && Cookies.get(DMM_AUTH_COOKIE)) {
        // Logout of DMM as well
        history.hardReplace(EIKAIWA_LOGOUT_ROUTE);
      } else {
        // Replace history state so the user doesn't go back to the logout page.

        const { redirectTo } = getQuery(history);

        history.replace(
          // Treat redirectTo being an array as malformed input,
          // only accept non-empty strings
          redirectTo && typeof redirectTo === 'string'
          ? redirectTo
          : RootRoute.getPathname(),
        );
      }
    });
  }

  public render() {
    return null;
  }
}

const LogoutInjectDependencies = (props: Subtract<IProps, IDeps>) => {
  const brand = useBrand();
  return (
    <Logout currentBrand={brand} {...props} />
  );
};
// Using connect to bind dispatch to revokeAuth directly. It gets injected as a prop
export default applyMixins(
  withHistory,
  connect(null, { revokeAuth }),
)(LogoutInjectDependencies);
